<template lang="pug">
  v-app.gvl-vue
    router-view
    vue-snotify

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class App extends Vue {

}
</script>
